import OTPInput from './OTPInput'

export default OTPInput
